module.exports = __webpack_public_path__ + "static/media/photo4.aacbbc65.jpg";